/** <!-- 允许负数，最多 2 位小数 -->
<el-input v-model="price" v-number-range="{ allowNegative: true, precision: 2 }" />

<!-- 不允许负数，最多 3 位小数 -->
<el-input v-model="rate" v-number-range="{ allowNegative: false, precision: 3 }" />

<!-- 只能整数（不允许小数点） -->
*
*
<el-input v-model="count" v-number-range="{ precision: 0 }" />*!/*/
// 数字指令：允许负数和小数，仍可配置范围/是否允许 0
export const numberRange = {
    bind(el, binding) {
        const input = el.querySelector && el.querySelector('input')
        if (!input) return

        const parseCfg = (val) => {
            // precision: 允许的小数位数（0 表示只能整数；null/undefined 表示不限）
            const cfg = {
                min: -Infinity,
                max: Infinity,
                allowZero: true,
                allowNegative: true,
                precision: undefined
            }
            if (val === undefined || val === null) return cfg

            if (typeof val === 'number') {
                cfg.max = Number(val)
                return cfg
            }

            if (typeof val === 'object') {
                if (val.min !== undefined) cfg.min = Number(val.min)
                if (val.max !== undefined) cfg.max = Number(val.max)
                if (val.allowZero !== undefined) cfg.allowZero = !!val.allowZero
                if (val.allowNegative !== undefined) cfg.allowNegative = !!val.allowNegative
                if (val.precision !== undefined && val.precision !== null) {
                    const p = Number(val.precision)
                    cfg.precision = Number.isFinite(p) ? Math.max(0, Math.floor(p)) : undefined
                }
                return cfg
            }

            return cfg
        }

        let cfg = parseCfg(binding && binding.value)

        const clampNumber = (num) => {
            let n = num
            if (!cfg.allowNegative && n < 0) n = Math.abs(n)
            if (n === 0 && !cfg.allowZero) return null
            if (n < cfg.min) n = cfg.min
            if (cfg.max !== Infinity && n > cfg.max) n = cfg.max
            return n
        }

        // 规范化为：可选 '-' + 数字 + 可选 '.' + 数字；并限制小数位
        const normalizeRawNumberString = (value) => {
            if (value === '') return ''

            // 符号处理
            let sign = ''
            if (value[0] === '-') {
                sign = '-'
                value = value.slice(1)
            }

            // 如果不允许负数，直接丢弃 '-'
            if (!cfg.allowNegative) {
                sign = ''
            }

            // 只保留数字和小数点
            value = value.replace(/[^0-9.]/g, '')

            // 只保留第一个小数点
            const firstDot = value.indexOf('.')
            if (firstDot !== -1) {
                const intPart = value.slice(0, firstDot)
                let fracPart = value.slice(firstDot + 1).replace(/\./g, '')

                // precision 限制
                if (cfg.precision !== undefined) {
                    fracPart = fracPart.slice(0, cfg.precision)
                }

                return sign + (intPart === '' ? '0' : intPart) + '.' + fracPart
            }

            // 没有小数点时直接返回纯整数
            // 去掉多余前导 0（保留单个 0）
            value = value.replace(/^0+(?=\d)/, '')
            return sign + value
        }

        const isIntermediate = (str) => {
            // 这些属于输入过程中的“中间态”，要保留，不要立刻转成 Number
            // '-' / '0.' / '-0.' / '12.' / '-12.' / ''
            if (str === '' || str === '-') return true
            if (/^-?\d+\.$/.test(str)) return true
            if (/^-?0\.$/.test(str)) return true
            return false
        }

        const applySanitize = () => {
            const raw = input.value || ''
            const normalized = normalizeRawNumberString(raw)

            // 先把非法字符清掉（但仍保留中间态）
            if (normalized !== raw) {
                input.value = normalized
                input.dispatchEvent(new Event('input', { bubbles: true }))
                return
            }

            // 中间态：允许继续输入，不做数值钳制，否则会导致 '.' 打不上去
            if (isIntermediate(normalized)) {
                // 如果只输入 '-' 但不允许负数，立刻清空
                if (normalized === '-' && !cfg.allowNegative) {
                    input.value = ''
                    input.dispatchEvent(new Event('input', { bubbles: true }))
                }
                return
            }

            // 走到这里说明已经是可解析的数字
            const num = Number(normalized)
            if (Number.isNaN(num)) {
                input.value = ''
                input.dispatchEvent(new Event('input', { bubbles: true }))
                return
            }

            const clamped = clampNumber(num)
            if (clamped === null) {
                input.value = ''
                input.dispatchEvent(new Event('input', { bubbles: true }))
                return
            }

            // precision：不再用 toFixed，避免补 0 导致小数部分难以编辑；只截断超出的位数
            const formatWithPrecision = (n) => {
                if (cfg.precision === undefined) return String(n)
                if (cfg.precision === 0) return String(Math.trunc(n))
                const parts = String(n).split('.')
                const intPart = parts[0]
                const fracPart = (parts[1] || '').slice(0, cfg.precision)
                return fracPart ? `${intPart}.${fracPart}` : intPart
            }

            const finalStr = formatWithPrecision(clamped)

            if (finalStr !== input.value) {
                input.value = finalStr
                input.dispatchEvent(new Event('input', { bubbles: true }))
            }
        }

        const onInput = () => applySanitize()

        const onKeydown = (e) => {
            const { key } = e
            const allowedKeys = [
                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                'Tab', 'Enter', 'Home', 'End', 'Escape'
            ]
            if (allowedKeys.indexOf(key) !== -1) return
            if (e.ctrlKey || e.metaKey) return

            // '-'：仅允许出现在最开头，且只允许一个，并且配置允许负数
            if (key === '-') {
                if (!cfg.allowNegative) {
                    e.preventDefault()
                    return
                }
                const value = input.value || ''
                const start = input.selectionStart || 0
                const hasMinus = value.indexOf('-') !== -1
                if (!hasMinus && start === 0) return
                e.preventDefault()
                return
            }

            // '.'：precision=0 时不允许输入小数点；否则只允许一个
            if (key === '.') {
                if (cfg.precision === 0) {
                    e.preventDefault()
                    return
                }
                const value = input.value || ''
                const selectionStart = input.selectionStart || 0
                const selectionEnd = input.selectionEnd || 0
                const before = value.slice(0, selectionStart)
                const after = value.slice(selectionEnd)
                const futureValue = before + '.' + after
                if (futureValue.indexOf('.') === futureValue.lastIndexOf('.')) return
                e.preventDefault()
                return
            }

            // 数字
            if (/^[0-9]$/.test(key)) {
                // 如果有 precision 限制，并且光标在小数点后，限制小数位输入长度
                if (cfg.precision !== undefined) {
                    const value = input.value || ''
                    const dotIndex = value.indexOf('.')
                    if (dotIndex !== -1) {
                        const start = input.selectionStart == null ? value.length : input.selectionStart
                        const isInFraction = start > dotIndex
                        if (isInFraction) {
                            const currentFraction = value.slice(dotIndex + 1)
                            // 如果是选中替换，则允许
                            const selectionStart = input.selectionStart || 0
                            const selectionEnd = input.selectionEnd || 0
                            const selectingWithinFraction = selectionEnd > dotIndex + 1
                            const hasSelection = selectionEnd > selectionStart
                            if (!hasSelection && !selectingWithinFraction && currentFraction.length >= cfg.precision) {
                                e.preventDefault()
                                return
                            }
                        }
                    }
                }
                return
            }

            e.preventDefault()
        }

        const onBlur = () => {
            // 失焦时把中间态收敛成规范值
            const v = input.value || ''
            if (v === '-' || v === '' || /^-?\d+\.$/.test(v)) {
                // '-' / '12.' 这种直接去掉末尾 '.' 或清空
                const normalized = v.replace(/\.$/, '')
                input.value = normalized === '-' ? '' : normalized
                applySanitize()
            }
        }

        const onPaste = (e) => {
            const clipboard = (e.clipboardData || window.clipboardData)
            const text = (clipboard && clipboard.getData('text')) || ''
            if (!text) return

            e.preventDefault()
            const start = input.selectionStart || 0
            const end = input.selectionEnd || 0
            const current = input.value || ''

            // 先拼接，再统一 normalize
            const nextRaw = current.slice(0, start) + text + current.slice(end)
            input.value = nextRaw
            applySanitize()
        }

        const updateCfg = (newBinding) => {
            cfg = parseCfg(newBinding && newBinding.value)
            applySanitize()
        }

        input._numberRangeHandlers = { onInput, onKeydown, onPaste, onBlur, updateCfg }
        input.addEventListener('input', onInput)
        input.addEventListener('keydown', onKeydown)
        input.addEventListener('paste', onPaste)
        input.addEventListener('blur', onBlur)
    },
    update(el, binding) {
        const input = el.querySelector && el.querySelector('input')
        if (!input || !input._numberRangeHandlers) return
        input._numberRangeHandlers.updateCfg(binding)
    },
    unbind(el) {
        const input = el.querySelector && el.querySelector('input')
        if (!input || !input._numberRangeHandlers) return
        const { onInput, onKeydown, onPaste, onBlur } = input._numberRangeHandlers
        input.removeEventListener('input', onInput)
        input.removeEventListener('keydown', onKeydown)
        input.removeEventListener('paste', onPaste)
        input.removeEventListener('blur', onBlur)
        delete input._numberRangeHandlers
    }
}

export default numberRange